<template>
    <div class="profil">
        <AppMain>


            <div class="nk-content-inner">
    <div class="nk-content-body">
        <div class="nk-block">
            <div class="card card-bordered">
                <div class="card-aside-wrap">


           

                    <div class="card-inner card-inner-lg" v-show="aktifSekme === 'bilgiler'">
                        <div class="nk-block-head nk-block-head-lg">
                            <div class="nk-block-between">
                                <div class="nk-block-head-content">
                                    <h4 class="nk-block-title">Profil Düzenle</h4>
                                    <div class="nk-block-des">
                                        <p>Bilgilerinizi Düzenleyin.</p>
                                    </div>
                                </div>
                                <div class="nk-block-head-content align-self-start d-lg-none"><a href="#"
                                        class="toggle btn btn-icon btn-trigger mt-n1" data-target="userAside"><em
                                            class="icon ni ni-menu-alt-r"></em></a></div>
                            </div>
                        </div>
                        <div class="nk-block">
                           
                            <form @submit.prevent="guncelle">

                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.profil }"> 
                                <label  class="col-lg-2 col-md-3 col-sm-4 col-form-label" for="profil">Profil</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <picture-input 
                                    ref="profil"
                                    width="300" 
                                    height="300" 
                                    margin="16" 
                                    accept="image/jpeg,image/png" 
                                    size="10" 
                                    button-class="btn"
                                    :custom-strings="{
                                        upload: '<h1>Profil</h1>',
                                        drag: 'Tıklayın veya sürükleyip bırakın'
                                    }"
                                    @change="profilDegistir">
                                    </picture-input>
                                    <span v-if="formHatalar.profil" class="error">{{ formHatalar.profil }}</span>
                                </div>	
                            </div>	

                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.ad }"> 
                                <label for="ad" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Ad</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.ad" class="form-control"/>
                                    <span v-if="formHatalar.ad" class="error">{{ formHatalar.ad }}</span>
                                </div>
                            </div>	
                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.soyad }"> 
                                <label for="soyad" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Soyad</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.soyad" class="form-control"/>
                                    <span v-if="formHatalar.soyad" class="error">{{ formHatalar.soyad }}</span>
                                </div>
                            </div>

                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.kullaniciadi }"> 
                                <label for="kullaniciadi" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Kullanıcı Adı</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.kullaniciadi" class="form-control"/>
                                    <span v-if="formHatalar.kullaniciadi" class="error">{{ formHatalar.kullaniciadi }}</span>
                                </div>
                            </div>

                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.sifre }"> 
                                <label for="sifre" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Yeni Şifre</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.sifre" class="form-control"/>
                                    <span v-if="formHatalar.sifre" class="error">{{ formHatalar.sifre }}</span>
                                </div>
                            </div>

                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.sifre2 }"> 
                                <label for="sifre2" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Yeni Şifre Tekrarı</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.sifre2" class="form-control"/>
                                    <span v-if="formHatalar.sifre2" class="error">{{ formHatalar.sifre2 }}</span>
                                </div>
                            </div>



                            
                            <div class="mb-3 row" :class="{ 'text-danger': formHatalar.telefon }"> 
                                <label for="telefon" class="col-lg-2 col-md-3 col-sm-4 col-form-label">Telefon</label> 
                                <div class="col-sm-8 col-md-9 col-lg-10">
                                    <input id="ad" v-model="profil.telefon" class="form-control"/>
                                    <span v-if="formHatalar.telefon" class="error">{{ formHatalar.telefon }}</span>
                                </div>
                            </div>




                            <div class="mb-3 row mt-5">
                                <div class="col-sm-8 col-md-9 col-lg-10 ms-auto">
                                    <button class="btn btn-primary" type="submit">Güncelle</button>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>

                    <div class="card-inner card-inner-lg" v-show="aktifSekme === 'hareketler'">
                        <div class="nk-block-head nk-block-head-lg">
                            <div class="nk-block-between">
                                <div class="nk-block-head-content">
                                    <h4 class="nk-block-title">Kullanıcı Hareketlerim</h4>
                                    <div class="nk-block-des">
                                        <p>Yapılan Eylemler</p>
                                    </div>
                                </div>
                                <div class="nk-block-head-content align-self-start d-lg-none"><a href="#"
                                        class="toggle btn btn-icon btn-trigger mt-n1" data-target="userAside"><em
                                            class="icon ni ni-menu-alt-r"></em></a></div>
                            </div>
                        </div>
                        <div class="nk-block">

                            <div class="timeline">
                                                <h6 class="timeline-head">Aktiviteler</h6>
                                                <ul class="timeline-list">

                                                    <li class="timeline-item" v-for="aktivite in paginatedaktiviteler" :key="aktivite.id">
                                                        <div class="timeline-status bg-primary is-outline"></div>
                                                        <div class="timeline-date">{{ $globalVariable.formatDateTime(aktivite.tarih)  }}<em class="icon ni ni-alarm-alt"></em></div>
                                                        <div class="timeline-data">
                                                            <h6 class="timeline-title">{{ aktivite.aciklama  }}</h6>
                                                            <div class="timeline-des">
                                                                <p>{{ aktivite.tarayici  }}</p>
                                                                <span class="time">{{ aktivite.url  }} - {{ aktivite.ip  }}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                   
                                                   
                                                  
                                                </ul>
                                            </div>



                     
                      
                        </div>

                       
                                            <ul class="pagination justify-content-center justify-content-md-start" style="margin-top: 50px;">
                                            <li :class="{ active: page === aktiviteler.seciliSayfa, 'page-item': true }" v-for="page in pages"
                                                :key="page">
                                                <a class="page-link" href="#" @click="aktivitelerSayfaDegistir(page)">{{ page }}</a>
                                            </li>

                                            </ul>
                                      
                    </div>
            
                    <div class="card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg toggle-screen-lg"
                        data-toggle-body="true" data-content="userAside" data-toggle-screen="lg"
                        data-toggle-overlay="true">
                        <div class="card-inner-group" data-simplebar="init">
                            <div class="simplebar-wrapper" style="margin: 0px;">
                                <div class="simplebar-height-auto-observer-wrapper">
                                    <div class="simplebar-height-auto-observer"></div>
                                </div>
                                <div class="simplebar-mask">
                                    <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                        <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                            aria-label="scrollable content" style="height: auto; overflow: hidden;">
                                            <div class="simplebar-content" style="padding: 0px;">
                                                <div class="card-inner">
                                                    <div class="user-card">
                                                        <div class="user-avatar bg-primary">
                                                            <img :src="$globalVariable.uploadUrl + profil.profil"
                                                @error="$globalVariable.varsayilanGorsel" >
                                                        </div>
                                                        <div class="user-info"><span class="lead-text">{{ profil.ad }} {{ profil.soyad }}</span><span
                                                                class="sub-text">{{ profil.rol }}</span></div>
                                                        
                                                    </div>
                                                </div>
                                                <div class="card-inner">
                                                    <div class="user-account-info py-0">
                                                        <h6 class="overline-title-alt">BİLGİLER </h6>
                                                        <div class="user-balance-sub">Telefon <span>{{ profil.telefon }} </span></div>
                                                        <div class="user-balance-sub">Kullanıcı Adı <span>{{ profil.kullaniciadi }} </span></div>
                                                        
                                                    </div>
                                                </div>
                                                <div class="card-inner p-0">
                                                    <ul class="link-list-menu">
                                                        <li><a  href="#" :class="{ 'active': aktifSekme === 'bilgiler'}"
                                            @click="aktifSekmeDegistir('bilgiler')"><em
                                                                    class="icon ni ni-user-fill-c"></em><span>Bilgiler</span></a></li>
                                                       
                                                        <li><a href="#" :class="{ 'active': aktifSekme === 'hareketler'}"
                                            @click="aktifSekmeDegistir('hareketler')"><em
                                                                    class="icon ni ni-activity-round-fill"></em><span>Hareketlerim</span></a></li>
                                                      
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="simplebar-placeholder" style="width: auto; height: 504px;"></div>
                            </div>
                            <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                            </div>
                            <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





        </AppMain>
    </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";
import PictureInput from 'vue-picture-input'
export default {
    name: "ProfilView",
    components: {
        AppMain,
        PictureInput,

    },
    data() {
        return {
            profil: [],
            
            aktiviteler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 10,
                arananKelime: "",
                islem: '',
                modal: false,
            },
            formHatalar:{},
            profilSecili: null,
            aktifSekme:'bilgiler'
        };
    },
    computed: {
 
 paginatedaktiviteler() {
   const start = (this.aktiviteler.seciliSayfa - 1) * this.aktiviteler.sayfadaKayit;
   const end = start + this.aktiviteler.sayfadaKayit;
   return this.aktiviteler.tumu.slice(start, end);
 },
 aktiviteler_toplamSayfa() {
   const totalFilteredUsers = this.aktiviteler.tumu.length;
   const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.aktiviteler.sayfadaKayit), 1);
   if (this.aktiviteler.seciliSayfa > maxPage) {
     this.aktivitelerSayfaDegistir(maxPage);
   }
   return maxPage;
 },
 pages() {
     const totalPageCount = this.aktiviteler_toplamSayfa;
     const maxVisiblePages = 5;
     const currentPage = this.aktiviteler.seciliSayfa;

     if (totalPageCount <= maxVisiblePages) {
         return Array.from({ length: totalPageCount }, (_, index) => index + 1);
     }

     const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
     const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

     return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
 },

},
    mounted() {
        this.profilGetir();
        this.hareketlerGetir();
    },
    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },
        profilGetir() {
            axiosCustom
                .get("profil")
                .then((response) => {
                    this.profil = response.data;
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },
        hareketlerGetir() {
            axiosCustom
                .get("profil/hareketler")
                .then((response) => {
                this.aktiviteler.tumu = response.data;
                })
                .catch((error) => {
                console.error("Veri çekme hatası: ", error);
                });
            },
        formDogrula() {
        this.formHatalar = {};
        var kontrol=true;

        if (!this.profil.ad) {
          this.formHatalar.ad = "Ad boş bırakılamaz.";
          kontrol=false;
        }

        if (!this.profil.soyad) {
          this.formHatalar.soyad = "Soyad boş bırakılamaz.";
          kontrol=false;
        }
        
        if (!this.profil.kullaniciadi) {
          this.formHatalar.kullaniciadi = "Kullanıcı Adı boş bırakılamaz.";
          kontrol=false;
        }
        if (this.profil.sifre!=this.profil.sifre2) {
          this.formHatalar.sifre = "Şifreler Uyuşmuyor";
          this.formHatalar.sifre2 = "Şifreler Uyuşmuyor";
          kontrol=false;
        }
        

        return kontrol;
      },
      async  guncelle() {
        if(this.formDogrula()){
          const newFormData = new FormData();
          newFormData.append("ad", this.profil.ad ?? '');
          newFormData.append("soyad", this.profil.soyad ?? '');
          newFormData.append("kullaniciadi", this.profil.kullaniciadi ?? '');
          newFormData.append("sifre", this.profil.sifre ?? '');
          newFormData.append("sifre2", this.profil.sifre2 ?? '');
          newFormData.append("telefon", this.profil.telefon ?? '');
  
          newFormData.append("profil",  this.profilSecili);
          
          try {
          
            axiosCustom
              .post("profil/duzenle/", newFormData)
              .then(() => {
                this.$toast.success("Profil Düzenlendi");
                this.profilGetir();
              })
              .catch((error) => {
                console.error("Güncelleme hatası: ", error);
                this.$toast.error("Güncelleme hatası");
              });
       
        } catch (error) {
            console.error('Kaydetme hatası: ', error);
            this.$toast.error('Kaydetme hatası');
          }
        }
      },


      aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
        },
        aktivitelerSayfaDegistir(page) {
            this.aktiviteler.seciliSayfa= page;
        },
      profilDegistir(event) {
            // Dosya seçildiğinde bu metod çağrılır
            this.profilSecili = event.target.files[0];

            // Resmin önizlemesini gösterme
            if (this.profilSecili) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    this.profilOnizleme = e.target.result;
                };

                reader.readAsDataURL(this.profilSecili);
            }
        },

    },
};
</script>
  